module.exports = __webpack_public_path__ + "246f6cb75f8f81a155b16f24847026f2.jpg";